import { useAuthCallbackRedirect } from '../hooks/useAuthCallbackRedirect';
import { AUTH_CALLBACK_ERROR_QUERY_PARAM } from '../utils/authCallback';

export interface AuthCallbackPageProps {
  defaultRedirectPath: string;
  loginPath: string;
  loginCallbackPath?: string;
  spinnerClassName?: string;
}

const DEFAULT_SPINNER_CLASSNAME = 'h-32 w-32 animate-spin rounded-full border-b-2 border-t-2 border-foreground';

export const AuthCallbackPage = ({
  defaultRedirectPath,
  loginPath,
  loginCallbackPath,
  spinnerClassName = DEFAULT_SPINNER_CLASSNAME,
}: AuthCallbackPageProps) => {
  useAuthCallbackRedirect({
    defaultRedirectPath,
    loginPath,
    loginCallbackPath,
    errorQueryParam: AUTH_CALLBACK_ERROR_QUERY_PARAM,
  });

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <div className={spinnerClassName}></div>
    </div>
  );
};
